import { render } from "./MainSidebar.vue?vue&type=template&id=e9d191fc"
import script from "./MainSidebar.vue?vue&type=script&lang=js"
export * from "./MainSidebar.vue?vue&type=script&lang=js"

import exportComponent from "/Users/carterharrison/Documents/github/cf/api-platform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__